import ProductAccordion from "./ProductAccordion";

export default ProductAccordion;
